import ProductDisclaimers from '@app/components/pages/pdp/ProductDisclaimers';
import { AFFILIATION_DEALER } from '@app/constants/commonConstants';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styles from './CartDisclaimers.module.scss';

const CartDisclaimers = () => {
  const { t } = useTranslation();
  const isCatCorp = useSelector(s => s.common.isCatCorp);
  const currentOrderId = useSelector(s => s.orders.current);
  const currentOrder = useSelector(s => s.orders.byId[currentOrderId] || {});
  const isQuantityMergeEnabled =
    currentOrder.orderExtendAttribute?.isQuantityMergeEnabled;
  const ascendingOrderItems = useSelector(
    s => s.orders.byId[s.orders.current]?.ascendingOrderItems || []
  );
  const requiredRequestByDate = useSelector(
    s => s.checkout.requiredFields?.requestByDate
  );
  const requiredEquipmentInput = useSelector(
    s => s.checkout.requiredFields?.equipment
  );
  const displayQuickOrder = useSelector(
    s => s.shoppingPreferences.shoppingPreferencesData.displayQuickOrder
  );
  const taxDisclaimerMessageFooter = useSelector(
    s => s.orders.taxDisclaimerMessageFooter
  );
  const userAffiliation = useSelector(s => s.common.userAffiliation);
  const isDealerUser = userAffiliation === AFFILIATION_DEALER;
  const showQuickOrder = displayQuickOrder || isDealerUser;
  const hasItemsInCart = ascendingOrderItems.length > 0;
  const areRequiredFieldsPresent =
    requiredRequestByDate || requiredEquipmentInput || showQuickOrder;
  const showRequired = areRequiredFieldsPresent && !isCatCorp;
  const showDisclaimers = showRequired || hasItemsInCart;
  return showDisclaimers ? (
    <section
      className={`${styles['cart-disclaimers__container']} mb-3 col-lg-9 px-0`}
    >
      {showRequired && (
        <p className="d-print-none text-xs u-color--DarkGray mb-0">
          {t('CAT_PARTS_MANUALS_REQ_FIELDS')}
        </p>
      )}
      {hasItemsInCart ? (
        <ProductDisclaimers
          isQuantityMergeEnabled={isQuantityMergeEnabled}
          taxDisclaimerMessageFooter={taxDisclaimerMessageFooter}
        />
      ) : null}
    </section>
  ) : null;
};

export default CartDisclaimers;
